import ChannelRecordCard, { ChannelRecordCardSkeleton } from './ChannelRecordCard';

export default ChannelRecordCard;
export { ChannelRecordCardSkeleton };
